export default "__VITE_ASSET__d7T_ZDKj__"